<template>
  <div :data-froala-editor="froalaIndex"></div>
</template>

<script>
/**
 * @param FroalaEditor
 *
 * @description FroalaEditor szövegszerkesztő megjelítése és paraméterek beállítása
 */

import $ from 'jquery'
// import { csrf } from '@/utils'

// const csrfToken = csrf()
import { getLanguageCode } from '@/utils'
import floaraEditorConfig from '../utils/floaraEditorConfig'

require('../../node_modules/froala-editor/js/froala_editor.pkgd.min')
require('froala-editor/js/languages/hu')

let froalaIndex = 0
const froalaStore = []
export default {
  name: 'FroalaEditor',
  props: {
    config: {
      type: Object,
      default: null,
    },
    text: {
      type: String,
      default: '',
    },
    templateField: {
      type: String,
    },
  },
  data() {
    return {
      templateValue: '',
      editorValue: '',
      $element: null,
      $editor: null,
      editorInitialized: false,
      templateItems: [],
      froalaIndex: froalaIndex++,
      templateId: null,
      defaultConfig: {
        key: floaraEditorConfig.FroalaEditorKey,
        pluginsEnabled: null,
        charCounterCount: false,
        height: 300,
        enter: $.FroalaEditor.ENTER_DIV,
        imageUploadURL: '/node/api/DocumentStorages/uploadfroa',
        fileUploadURL: '/node/api/DocumentStorages/uploadfroa',
        language: getLanguageCode(),
        iframeDefaultStyle: 'body{overflow: auto;}',
        pasteDeniedAttrs: ['class', 'id', 'style'],
        tabSpaces: 4,
        lineHeights: {
          Default: '',
          Single: '1',
          1.15: '1.15',
          1.5: '1.5',
          Double: '2',
        },
        /*imageUploadParams: {
          [csrfToken.name]: csrfToken.value,
          meta: {}
        },*/
        entities:
          '&quot;&#39;&iexcl;&cent;&pound;&curren;&yen;&brvbar;&sect;&uml;&copy;&ordf;&laquo;&not;&shy;&reg;&macr;&deg;&plusmn;&sup2;&sup3;&acute;&micro;&para;&middot;&cedil;&sup1;&ordm;&raquo;&frac14;&frac12;&frac34;&iquest;&Agrave;&Acirc;&Atilde;&Auml;&Aring;&AElig;&Ccedil;&Egrave;&Ecirc;&Euml;&Igrave;&Icirc;&Iuml;&ETH;&Ntilde;&Ograve;&Ocirc;&Otilde;&times;&Oslash;&Ugrave;&Ucirc;&Yacute;&THORN;&szlig;&agrave;&acirc;&atilde;&auml;&aring;&aelig;&ccedil;&egrave;&ecirc;&euml;&igrave;&icirc;&iuml;&eth;&ntilde;&ograve;&ocirc;&otilde;&divide;&oslash;&ugrave;&ucirc;&yacute;&thorn;&yuml;&OElig;&oelig;&Scaron;&scaron;&Yuml;&fnof;&circ;&tilde;&Alpha;&Beta;&Gamma;&Delta;&Epsilon;&Zeta;&Eta;&Theta;&Iota;&Kappa;&Lambda;&Mu;&Nu;&Xi;&Omicron;&Pi;&Rho;&Sigma;&Tau;&Upsilon;&Phi;&Chi;&Psi;&Omega;&alpha;&beta;&gamma;&delta;&epsilon;&zeta;&eta;&theta;&iota;&kappa;&lambda;&mu;&nu;&xi;&omicron;&pi;&rho;&sigmaf;&sigma;&tau;&upsilon;&phi;&chi;&psi;&omega;&thetasym;&upsih;&piv;&ensp;&emsp;&thinsp;&zwnj;&zwj;&lrm;&rlm;&ndash;&mdash;&lsquo;&rsquo;&sbquo;&ldquo;&rdquo;&bdquo;&dagger;&Dagger;&bull;&hellip;&permil;&prime;&Prime;&lsaquo;&rsaquo;&oline;&frasl;&euro;&image;&weierp;&real;&trade;&alefsym;&larr;&uarr;&rarr;&darr;&harr;&crarr;&lArr;&uArr;&rArr;&dArr;&hArr;&forall;&part;&exist;&empty;&nabla;&isin;&notin;&ni;&prod;&sum;&minus;&lowast;&radic;&prop;&infin;&ang;&and;&or;&cap;&cup;&int;&there4;&sim;&cong;&asymp;&ne;&equiv;&le;&ge;&sub;&sup;&nsub;&sube;&supe;&oplus;&otimes;&perp;&sdot;&lceil;&rceil;&lfloor;&rfloor;&lang;&rang;&loz;&spades;&clubs;&hearts;&diams;',
        toolbarButtons: $.FroalaEditor.TOOLBAR_BUTTONS.concat('dynamic_values_dropdown'),
        tableStyles: {
          'fr-dashed-borders': 'Dashed borders',
          'fr-alternate-rows': 'Alternate rows',
          'fr-no-borders': 'No borders',
          'fr-align-right': 'Align right',
        },
        imageUploadMethod: 'POST',
        fileUploadMethod: 'POST',
        imageMaxSize: 10 * 1024 * 1024,
        imageAllowedTypes: ['jpeg', 'jpg', 'png'],
        fileAllowedTypes: [
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/zip',
          'application/pdf',
          'application/vnd.ms-powerpoint',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation',
          'application/rtf',
        ],
      },
    }
  },
  methods: {
    createCustomDropdown() {
      $.FroalaEditor.DefineIcon('dynamic_values_dropdown', { NAME: 'cog' })
      $.FroalaEditor.RegisterCommand('dynamic_values_dropdown', {
        title: 'Dynamic values',
        type: 'dropdown',
        focus: false,
        undo: false,
        options: this.dynamicValues,
        refreshAfterCallback: true,
        callback: function (cmd, val) {
          this.html.insert(`
            <span data-value="[[[${val}]]]"
              class="dynamic-froala-link fr-deletable"
              contenteditable="false">
              ${froalaStore[this.$el.parents('[data-froala-editor]').data('froala-editor')].dynamicValues[val]}
            </span>`)
        },
        // Callback on refresh.
        refresh: function ($btn) {},
        // Callback on dropdown show.
        refreshOnShow: function ($btn, $dropdown) {},
      })
    },
    generateEditorFormat(text = '') {
      return text.replace(
        /{d\..*?}/gm,
        (match) =>
          `<span class="dynamic-froala-link fr-deletable" contenteditable="false" data-value="[[[${match}]]]">${
            this.dynamicValues[match] || match
          }</span>`,
      )
    },
    generateTemplateFormat(text = '') {
      return text.replace(/<span class="dynamic-froala-link.*?data-value="\[\[\[(.*?)\]\]\]".*?<\/span>/gm, '$1')
    },
    getTemplateId() {
      const moduleName = Object.keys(this.$store.state)
        .sort()
        .filter((x) => x.includes('formStore'))
        .pop()
      const modul = this.$store.state[moduleName]
      const items = []
      let item = null

      modul.form.pages.forEach((page) => {
        page.groups.forEach((group) => {
          group.rows.forEach((row) => {
            row.forEach((item) => {
              items.push(item)
            })
          })
        })
      })

      item = items.find((x) => x.name === this.templateField)
      return item && item.value
    },
    async getTemplateItems() {
      const response = await this.$client
        .execute({
          operationId: 'Template_getTemplateItems',
          parameters: {
            id: this.templateId,
          },
        })
        .catch((e) => {
          console.error(e)
        })
      this.templateItems = /[2,3]\d\d/.test(response.status) ? response.body : []
    },

    createEditor() {
      if (this.editorInitialized) {
        return
      }

      this.$element = $(this.$el)

      this.$editor = this.$element.froalaEditor(this.currentConfig)

      this.$element.froalaEditor('html.set', this.editorValue)

      const self = this

      this.$element.on('froalaEditor.contentChanged', function () {
        const content = self.$element.froalaEditor('html.get')
        self.editorValue = content
        self.templateValue = self.generateTemplateFormat(content)
        self.$emit('change', { value: self.templateValue })
      })

      this.editorInitialized = true
    },
    destroyEditor() {
      if (this.$element) {
        this.$element.off().froalaEditor('destroy')
        this.$element = null
        this.editorInitialized = false
      }
    },
  },
  computed: {
    currentConfig() {
      return Object.assign(this.defaultConfig, this.config)
    },
    dynamicValues() {
      const result = this.templateItems.reduce((acc, item) => {
        return {
          ...acc,
          ...item.parameterOut.reduce(
            (sub, parameterOut) => ({
              ...sub,
              [`{d.${item.idTemplateItem}.${parameterOut.fieldName}}`]: `${item.name}.${parameterOut.fieldName}`,
              [`{d.${item.idTemplateItem}.items[i].${parameterOut.fieldName}}`]: `${item.name}.${parameterOut.fieldName} i`,
              [`{d.${item.idTemplateItem}.items[i+1].${parameterOut.fieldName}}`]: `${item.name}.${parameterOut.fieldName} i+1`,
            }),
            {},
          ),
        }
      }, {})
      return result
    },
  },
  watch: {
    templateValue: function (newValue) {
      this.$emit('input', newValue)
    },
  },
  components: {},
  async mounted() {
    froalaStore.push(this)
    if (this.templateField) {
      this.templateId = this.getTemplateId()
      await this.getTemplateItems()
    }
    this.editorValue = this.generateEditorFormat(this.text || '')
    this.templateValue = this.generateTemplateFormat(this.editorValue)
    Object.entries(this.dynamicValues).length > 0 && this.createCustomDropdown()
    this.createEditor()
  },
  destroyed() {
    this.destroyEditor()
  },
}
</script>

<style lang="scss">
@import '../../node_modules/font-awesome/css/font-awesome.min.css';
@import '../../node_modules/froala-editor/css/froala_editor.pkgd.min.css';
@import '../../node_modules/froala-editor/css/froala_style.min.css';
.dynamic-froala-link {
  background: green;
  color: white;
  display: inline-block;
  padding: 2px 5px;
  user-select: none;
}
.fr-command.fr-btn + .fr-dropdown-menu .fr-dropdown-wrapper .fr-dropdown-content ul.fr-dropdown-list {
  padding: 0 !important;
}
.fr-view pre {
  background-color: #eee;
  border: 1px solid #bbb;
  padding: 0 10px;
}
</style>
